module.exports = __webpack_public_path__ + "media/olha_tanta_luz.a7e1053c.mp3";